module.exports = __webpack_public_path__ + "static/media/banner_ktba03_640_200 1.92ba0635.png";